/* Capture and prepare before the only call that can expose audio to a peer. */
export async function publishPreparedMicrophone<T extends { stop(): void }, P>({
  capture,
  prepare,
  current,
  publish,
}: {
  capture(): Promise<T>;
  prepare(track: T): Promise<void>;
  current(): boolean;
  publish(track: T): Promise<P>;
}): Promise<P | undefined> {
  let track: T;
  try {
    track = await capture();
  } catch (error) {
    console.error("Microphone capture failed:", error);
    return undefined;
  }
  let published = false;
  try {
    if (!current()) return;
    await prepare(track);
    if (!current()) return;
    const publication = await publish(track);
    published = true;
    return publication;
  } catch (error) {
    console.error("Microphone preparation or publication failed:", error);
    return undefined;
  } finally {
    if (!published) track.stop();
  }
}
